
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gYFpk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80177156cdfd0c4ec20061b3615d4605>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c5c25e9fec556e9f$var$_react = $c5c25e9fec556e9f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $c5c25e9fec556e9f$var$_logIn = $c5c25e9fec556e9f$var$_interopRequireDefault((parcelRequire("ilSNM")));

var $c5c25e9fec556e9f$var$_signIn = $c5c25e9fec556e9f$var$_interopRequireDefault((parcelRequire("iRXVy")));
function $c5c25e9fec556e9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LogInIcon.
 * This component is LogInIcon, with `UNSAFE_fallbackIcon` set to "SignInIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c5c25e9fec556e9f$var$LogInIcon = (props)=>/*#__PURE__*/ $c5c25e9fec556e9f$var$_react.default.createElement($c5c25e9fec556e9f$var$_logIn.default, Object.assign({
        LEGACY_fallbackIcon: $c5c25e9fec556e9f$var$_signIn.default
    }, props));
$c5c25e9fec556e9f$var$LogInIcon.Name = 'LogInIconMigration';
var $c5c25e9fec556e9f$var$_default = module.exports.default = $c5c25e9fec556e9f$var$LogInIcon;

});


//# sourceMappingURL=log-in--sign-in.7f99aafe.js.map
